import React from 'react';
import { Navigate } from 'react-router-dom';
import { useComplianceMode } from '../context/compliance-mode-context.jsx';
import { resolveFinancialRouteAccess } from '../model/compliance-visibility.js';

function FinancialRegulationRoute({ children }) {
  const { isLoading, isFinancialRegulation } = useComplianceMode();
  const access = resolveFinancialRouteAccess({ isLoading, isFinancialRegulation });

  if (access === 'loading') {
    return <div className="text-muted">Loading compliance settings...</div>;
  }

  if (access === 'redirect') {
    return <Navigate to="/system/settings/general" replace />;
  }

  return children;
}

export default FinancialRegulationRoute;
